// actions/employee-onboarding/approve.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// approve

export function approveHasErrored(bool) {
  return {
    type: 'ONBOARDING_APPROVE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function approveIsLoading(bool) {
  return {
    type: 'ONBOARDING_APPROVE_IS_LOADING',
    isLoading: bool
  };
}

export function approveFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_APPROVE_FETCH_DATA_SUCCESS',
    data
  };
}

export function approveFetchData(host, params) {
  return (dispatch) => {
    dispatch(approveIsLoading(true));
    dispatch(approveHasErrored(false));
    fetch(host + 'approve/approve?approve_id=' + params.approve + '&deny_id=' + params.deny, {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        dispatch(approveFetchDataSuccess(params));
        dispatch(approveHasErrored(false));
        dispatch(approveIsLoading(false));
        PubSub.publish('employee.approve.approve', params);
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(approveHasErrored(true));
      dispatch(approveIsLoading(false));
    });
  };
}

// approveCheck

export function approveCheckHasErrored(bool) {
  return {
    type: 'ONBOARDING_APPROVE_CHECK_HAS_ERRORED',
    hasErrored: bool
  };
}

export function approveCheckIsLoading(bool) {
  return {
    type: 'ONBOARDING_APPROVE_CHECK_IS_LOADING',
    isLoading: bool
  };
}

export function approveCheckFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_APPROVE_CHECK_FETCH_DATA_SUCCESS',
    data
  };
}

export function approveCheckFetchData(host, params) {
  return (dispatch) => {
    dispatch(approveCheckIsLoading(true));
    dispatch(approveCheckHasErrored(false));
    fetch(host + 'approve/approved', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(approveCheckFetchDataSuccess(result));
            dispatch(approveCheckHasErrored(false));
            dispatch(approveCheckIsLoading(false));
            PubSub.publish('employee.approve.approveCheck', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(approveCheckHasErrored(true));
            dispatch(approveCheckIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(approveCheckHasErrored(true));
      dispatch(approveCheckIsLoading(false));
    });
  };
}